if (!customElements.get('product-action-bar')) {
  class ProductActionBar extends HTMLElement {
    constructor() {
      super();
      this.position = this.dataset.position;
      this.areVariantsEmpty = Array.from(this.querySelectorAll('.product-action-bar-variants .product-form__input, .product-action-bar-variants .product-variant-accordion')).filter(element => !element.classList.contains('visually-hidden')).length == 0;
      this.optionDetails = this.querySelector('.product-action-bar-variants');
      this.buyButtons = this.querySelector('.product-buy-buttons');
      this.detailsElements = this.querySelectorAll('.product-action-bar-variants details');
      if (this.classList.contains('product-action-bar--condensed')) {
        this.setCondensedHeight();
        this.setDropdownsCount();
        this.detailsElements.forEach(detail => {
          detail.querySelector('summary').addEventListener('click', (e) => {
            if (e.isTrusted) {
              this.onCondensedDropdownClick(detail);
            }
          });
        })
      }
      if (this.position == 'sticky') {
        this.paddingOffset = 20;
        this.stickyType = this.dataset.stickyType;
        this.infoContainer = document.querySelector('.product__info-container');
        this.staticVariantsElement = this.infoContainer.querySelectorAll('variant-selects')[0];
        this.staticBuyButtons = this.infoContainer.querySelectorAll('.product-buy-buttons')[0];
        this.staticFistBlock = this.infoContainer.querySelectorAll('variant-selects, .product-buy-buttons')[0];
        this.hideContainerBlocks();
        window.addEventListener('scroll', this.hideContainerBlocks.bind(this));
      } else if (this.position == 'fixed') {
        this.addBodyPadding();
        this.detailsElements.forEach(detail => {
          detail.addEventListener('click', () => {
            setTimeout(() => {
              this.addBodyPadding();
            });
          });
        })
        if (this.dataset.fixedType == 'scroll') {
          this.currentScroll = window.scrollY;
          window.addEventListener('scroll', this.onFixedScroll.bind(this))
        }
      }
      if (this.dataset.variantType == 'dropdowns' && this.hasAttribute('swipe-dropdowns')) {
        this.swipeDropdowns();
      }
    }

    setCondensedHeight() {
      const variantsHeight = (this.optionDetails && this.dataset.variantType != 'one_dropdown') ? Math.ceil(this.optionDetails.clientHeight) : 0
      const buyHeight = this.buyButtons ? Math.ceil(this.buyButtons.clientHeight) : 0
      if (variantsHeight != 0 || buyHeight != 0)
        this.style.setProperty('--actions-height', `${(variantsHeight > buyHeight) ? variantsHeight : buyHeight}px`)
    }


    setDropdownsCount() {
      const dropdowns = this.querySelectorAll('.product__accordion:not(.small-hide)');
      this.style.setProperty('--dropdowns-count', dropdowns.length);
    }

    hideContainerBlocks() {
      if (this.stickyType === 'info' && this.infoContainer) {
        if (this.infoContainer.getBoundingClientRect().top <= (window.innerHeight - this.paddingOffset)) {
          this.classList.add('hide-self');
        } else {
          this.classList.remove('hide-self');
        }
      } else if (this.stickyType === 'first_block' && this.staticFistBlock) {
        if (this.staticFistBlock.getBoundingClientRect().bottom <= (window.innerHeight - this.paddingOffset)) {
          this.classList.add('hide-self');
        } else {
          this.classList.remove('hide-self');
        }
      } else {
        if (this.optionDetails && this.staticVariantsElement) {
          if (this.staticVariantsElement.getBoundingClientRect().bottom <= (window.innerHeight - this.paddingOffset)) {
            this.optionDetails.classList.add('small-hide');
          } else {
            this.optionDetails.classList.remove('small-hide');
          }
        }

        if (this.staticBuyButtons && this.buyButtons) {
          if (this.staticBuyButtons.getBoundingClientRect().bottom <= (window.innerHeight - this.paddingOffset)) {
            this.buyButtons.classList.add('small-hide');
          } else {
            this.buyButtons.classList.remove('small-hide');
          }
        }

      }

      if (this.areVariantsEmpty) {
        this.optionDetails.classList.add('small-hide')
      }
    }

    addBodyPadding() {
      document.body.style.setProperty('--product-action-bar-offset', `${this.clientHeight}px`);
      if (this.areVariantsEmpty) {
        this.optionDetails.classList.add('small-hide')
      }
    }

    onFixedScroll(e) {
      e.preventDefault();
      const scrollTop = window.scrollY || document.documentElement.scrollTop

      if (scrollTop >= this.currentScroll && scrollTop > 200) {
        this.classList.add('hide-self');
        document.body.style.setProperty('--product-action-bar-offset', `0px`);
      } else {
        this.classList.remove('hide-self');
        document.body.style.setProperty('--product-action-bar-offset', `${this.clientHeight}px`);
      }

      this.currentScroll = scrollTop
    }

    swipeDropdowns() {
      this.detailsElements.forEach(detail => {
        const content = detail.querySelector('.accordion__content');
        content.classList.add('grab-mouse');
        let isDragging = false;
        let startX;
        let scrollLeft;

        // Mouse events
        content.addEventListener('mousedown', (e) => {
          isDragging = true;
          e.preventDefault();
          content.classList.add('grabbing-mouse');
          content.classList.remove('grab-mouse');
          startX = e.pageX - content.offsetLeft;
          scrollLeft = content.scrollLeft;
        });

        content.addEventListener('mouseleave', () => {
          isDragging = false;
          content.classList.remove('grabbing-mouse');
          content.classList.add('grab-mouse');
        });

        content.addEventListener('mouseup', () => {
          isDragging = false;
          content.classList.remove('grabbing-mouse');
          content.classList.add('grab-mouse');
        });

        content.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          e.preventDefault();
          const x = e.pageX - content.offsetLeft;
          const walk = (x - startX) * 2; // Multiplied by 2 for faster scrolling
          content.scrollLeft = scrollLeft - walk;
        });

      })

    }

    onCondensedDropdownClick(target) {
      target.classList.add('opening');
      setTimeout(() => {
        this.detailsElements.forEach(detail => {
          if (detail != target && detail.open == true) {
            detail.querySelector('summary').click();
          }
        })
      }, 200);
      setTimeout(() => {
        target.classList.remove('opening');
      }, 500);
    }
  }

  customElements.define('product-action-bar', ProductActionBar);
}